/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Failed_Dns_RecorInputs */

const en_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification failed. DNS records usually take 10-30 minutes to propagate.`)
};

const es_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo en la verificación. Los registros DNS suelen tardar entre 10 y 30 minutos en propagarse.`)
};

const fr_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la vérification. Les enregistrements DNS prennent généralement 10 à 30 minutes pour se propager.`)
};

const de_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierung fehlgeschlagen. Die Verbreitung von DNS-Einträgen dauert in der Regel 10-30 Minuten.`)
};

const ja_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証に失敗しました。DNSレコードの伝播には通常10〜30分かかります。`)
};

const zh_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证失败。DNS 记录通常需要 10-30 分钟才能生效。`)
};

const ar_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل التحقق. عادةً ما تستغرق سجلات DNS من 10 إلى 30 دقيقة للانتشار.`)
};

const id_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi gagal. Rekaman DNS biasanya memakan waktu 10-30 menit untuk berpropagasi.`)
};

const it_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica fallita. I record DNS impiegano solitamente 10-30 minuti per propagarsi.`)
};

const ru_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верификация не удалась. Обычно обновление записей DNS занимает 10-30 минут.`)
};

const pt_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na verificação. Os registros DNS geralmente levam de 10 a 30 minutos para propagar.`)
};

const ko_verification_failed_dns_recor = /** @type {(inputs: Verification_Failed_Dns_RecorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`검증 실패. DNS 레코드가 전파되는 데 일반적으로 10-30분이 소요됩니다.`)
};

/**
* | output |
* | --- |
* | "Verification failed. DNS records usually take 10-30 minutes to propagate." |
*
* @param {Verification_Failed_Dns_RecorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verification_failed_dns_recor = /** @type {((inputs?: Verification_Failed_Dns_RecorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Failed_Dns_RecorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verification_failed_dns_recor(inputs)
	if (locale === "es") return es_verification_failed_dns_recor(inputs)
	if (locale === "fr") return fr_verification_failed_dns_recor(inputs)
	if (locale === "de") return de_verification_failed_dns_recor(inputs)
	if (locale === "ja") return ja_verification_failed_dns_recor(inputs)
	if (locale === "zh") return zh_verification_failed_dns_recor(inputs)
	if (locale === "ar") return ar_verification_failed_dns_recor(inputs)
	if (locale === "id") return id_verification_failed_dns_recor(inputs)
	if (locale === "it") return it_verification_failed_dns_recor(inputs)
	if (locale === "ru") return ru_verification_failed_dns_recor(inputs)
	if (locale === "pt") return pt_verification_failed_dns_recor(inputs)
	return ko_verification_failed_dns_recor(inputs)
});